// Shared id for the sr-only step-progress h2 (see doc/jaws-voiceover-accessibility-reference.md §5).
// Referenced from each step h1 via aria-describedby so AT reads: title, then progress, then other descriptions.

export const STEP_PROGRESS_HEADING_ID = 'onboarding-step-progress'

export const stepDescribedBy = (...descriptionIds) =>
  [STEP_PROGRESS_HEADING_ID, ...descriptionIds.filter(Boolean)].join(' ')
